import jwt_decode from "jwt-decode";
import cookie from "cookie";

export interface ICookiesInfo {
	userName: string;
	userFirstLastName: string;
	userId: string;
	facilityId: string;
	facilityName: string;
	posTerminalExists: boolean;
	hostDomain: string;
	printer2Exists: boolean;
	posTerminalId: string;
}

export const cookiesInfoStates = {
	cookiesInfo: {
		userId: "",
		userName: "",
		userFirstLastName: "",
		facilityId: "",
		facilityName: "",
	} as ICookiesInfo,
};

const cookiesInfoReducer = () => {
	return {
		getCookiesInfo: (state) => {
			const parsedCookies = cookie.parse(document.cookie);
			const token =
				new URLSearchParams(window.location.search).get("authToken") ||
				parsedCookies["classic-bridge"];

			// The token can be missing (e.g. cookie blocked inside the iframe);
			// jwt_decode throws on that, which would crash the whole app.
			let jwtInfo: Record<string, string>;
			try {
				jwtInfo = jwt_decode<Record<string, string>>(token ?? "");
			} catch {
				return state;
			}

			return {
				...state,
				cookiesInfo: {
					...state.cookiesInfo,
					userName: jwtInfo["user.name"],
					userId: jwtInfo["user.id"],
					userFirstLastName: jwtInfo["user.firsLast"],
					facilityId: jwtInfo["facility.id"],
					facilityName: jwtInfo["facility.name"],
					posTerminalExists: parsedCookies.PosTerminalExists === "True",
					hostDomain: parsedCookies.HostDomain,
					printer2Exists: parsedCookies.Printer2Exists === "True",
					posTerminalId: parsedCookies.PosTerminalId ?? "",
				},
			};
		},
	};
};

export default cookiesInfoReducer;
